import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import { withStoreDetail } from '../Common/Providers/WithStoreDetail';
import { TransLink } from '../Common/Translations';
import config from '../../config';

class NavbarDark extends Component {

  render() {
    const selfHostedPaymentRegEx = /checkout.*shp/;
    const { store } = this.props;
    const hideNavbar = selfHostedPaymentRegEx.test(this.props.location.pathname) && isMobile;
    const darkNavbarUrl = selfHostedPaymentRegEx.test(this.props.location.pathname) ? '/checkout/shipping' : '/';
    return (
      !hideNavbar && <nav className="navbar navbar-dark bg-primary">
        <div className="container">
          <a href={darkNavbarUrl}>
            <img className="nav-brand mx-auto" id="logo" src={`${config.s3BucketUrl}/assets/general/pb-logo-white.png`} alt={store.name} width="180" style={{ height: 'auto' }} />
          </a>
        </div>
      </nav>
    );
  }
}

export default withStoreDetail(NavbarDark);
export const undecorated = NavbarDark;



// WEBPACK FOOTER //
// ./src/Nav/NavbarDark.js